/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChatIndexRouteImport } from './routes/chat/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as FolderFolderIdIndexRouteImport } from './routes/folder/$folderId/index'
import { Route as ChatConversationIdIndexRouteImport } from './routes/chat/$conversationId/index'
import { Route as AuthCallbackIndexRouteImport } from './routes/auth/callback/index'
import { Route as AdminAuditLogsIndexRouteImport } from './routes/admin/audit-logs/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const FolderFolderIdIndexRoute = FolderFolderIdIndexRouteImport.update({
  id: '/folder/$folderId/',
  path: '/folder/$folderId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatConversationIdIndexRoute = ChatConversationIdIndexRouteImport.update({
  id: '/chat/$conversationId/',
  path: '/chat/$conversationId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackIndexRoute = AuthCallbackIndexRouteImport.update({
  id: '/auth/callback/',
  path: '/auth/callback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditLogsIndexRoute = AdminAuditLogsIndexRouteImport.update({
  id: '/admin/audit-logs/',
  path: '/admin/audit-logs/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin/': typeof AdminIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/auth/callback/': typeof AuthCallbackIndexRoute
  '/chat/$conversationId/': typeof ChatConversationIdIndexRoute
  '/folder/$folderId/': typeof FolderFolderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminIndexRoute
  '/chat': typeof ChatIndexRoute
  '/admin/audit-logs': typeof AdminAuditLogsIndexRoute
  '/auth/callback': typeof AuthCallbackIndexRoute
  '/chat/$conversationId': typeof ChatConversationIdIndexRoute
  '/folder/$folderId': typeof FolderFolderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin/': typeof AdminIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/admin/audit-logs/': typeof AdminAuditLogsIndexRoute
  '/auth/callback/': typeof AuthCallbackIndexRoute
  '/chat/$conversationId/': typeof ChatConversationIdIndexRoute
  '/folder/$folderId/': typeof FolderFolderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin/'
    | '/chat/'
    | '/admin/audit-logs/'
    | '/auth/callback/'
    | '/chat/$conversationId/'
    | '/folder/$folderId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/chat'
    | '/admin/audit-logs'
    | '/auth/callback'
    | '/chat/$conversationId'
    | '/folder/$folderId'
  id:
    | '__root__'
    | '/'
    | '/admin/'
    | '/chat/'
    | '/admin/audit-logs/'
    | '/auth/callback/'
    | '/chat/$conversationId/'
    | '/folder/$folderId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminIndexRoute: typeof AdminIndexRoute
  ChatIndexRoute: typeof ChatIndexRoute
  AdminAuditLogsIndexRoute: typeof AdminAuditLogsIndexRoute
  AuthCallbackIndexRoute: typeof AuthCallbackIndexRoute
  ChatConversationIdIndexRoute: typeof ChatConversationIdIndexRoute
  FolderFolderIdIndexRoute: typeof FolderFolderIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folder/$folderId/': {
      id: '/folder/$folderId/'
      path: '/folder/$folderId'
      fullPath: '/folder/$folderId/'
      preLoaderRoute: typeof FolderFolderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$conversationId/': {
      id: '/chat/$conversationId/'
      path: '/chat/$conversationId'
      fullPath: '/chat/$conversationId/'
      preLoaderRoute: typeof ChatConversationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback/': {
      id: '/auth/callback/'
      path: '/auth/callback'
      fullPath: '/auth/callback/'
      preLoaderRoute: typeof AuthCallbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit-logs/': {
      id: '/admin/audit-logs/'
      path: '/admin/audit-logs'
      fullPath: '/admin/audit-logs/'
      preLoaderRoute: typeof AdminAuditLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminIndexRoute: AdminIndexRoute,
  ChatIndexRoute: ChatIndexRoute,
  AdminAuditLogsIndexRoute: AdminAuditLogsIndexRoute,
  AuthCallbackIndexRoute: AuthCallbackIndexRoute,
  ChatConversationIdIndexRoute: ChatConversationIdIndexRoute,
  FolderFolderIdIndexRoute: FolderFolderIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
